import { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatText, formatAccomodationText} from "@utils/sharedFunctions";
export default function InputComponent(props:{list: any[] | undefined, setFilteredList: (list: any[]) => void, isAccomodation : boolean}){

    const {t} = useTranslation()
    const [text, setText] = useState("");

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const value = e.target.value;
    setText(value);

    if (!value) {
      props.setFilteredList(props.list ?? []);
      return;
    }

    let filtered;

    if(props.isAccomodation){
      filtered = formatAccomodationText(props.list ?? [], "name", value);
    }else{
      filtered = formatText(props.list ?? [], "title", value);
    }
    props.setFilteredList(filtered);
  }  

    return(
        <input 
        onChange={e=>handleChange(e)} 
        className="input-style" 
        placeholder={t("text.find")}
        value={text}
        />
    )
}